import {
  IScanTMRZAction,
  TesseractMrz,
} from "./../actions/types/scanTesseractMrzTypes";

const initialState: TesseractMrz = {
  loading: false,
  loaded: false,
  progress: 0,
  scanning: false,
  timer: 0,
};

export const scanTMRZReducer = (
  state: TesseractMrz = initialState,
  action: IScanTMRZAction<any>
): TesseractMrz => {
  switch (action.type) {
    case "INIT_CREATE":
      return {
        ...state,
        loading: true,
      };
    case "MRZ_PROGRESS": {
      return {
        ...state,
        progress: action.payload,
      };
    }
    case "MRZ_START": {
      return {
        ...state,
        scanning: true,
      };
    }
    case "MRZ_STOP": {
      return {
        ...state,
        scanning: false,
        timer: 0,
      };
    }
    case "MRZ_TIMER": {
      return {
        ...state,
        timer: state.timer + 1,
      };
    }
    default:
      return state;
  }
};
